import { composeIO } from 'react-compose-io'
import { uploadPlanilhaIO } from './UploadPlanilha.IO'
import { UploadPlanilhaView } from './UploadPlanilha.View'

export const UploadPlanilha = composeIO(UploadPlanilhaView, uploadPlanilhaIO)
